// 갤러리 페이지 번역
export default {
  page: {
    sectionLabel: 'Photo Gallery',
    title: 'Church Gallery',
    description: 'Browse through our collection of memorable moments and events from our church community.'
  },
  categories: {
    all: 'All'
  }
};
